import React, { useState } from "react";

import TabControls from "./TabControls";

export default function TemplateCard({ tabOptions, startingTab }) {
  const [currentTab, setCurrentTab] = useState(tabOptions[startingTab]);
  const [currentTabName, setCurrentTabName] = useState(startingTab);

  return (
    <div className="bg-white relative overflow-hidden shadow sm:rounded-lg h-[75%] overflow-y-scroll sm:h-fit w-full sm:w-fit sm:aspect-[3/2] rounded-lg">
      <div className="h-full max-w-4xl w-full sm:w-[700px] flex flex-col relative">
        <TabControls
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          currentTabName={currentTabName}
          setCurrentTabName={setCurrentTabName}
          tabOptions={tabOptions}
        />
        {currentTab}
      </div>
    </div>
  );
}
